export const siteInfo = {
  name: '高义白洁',
  tagline: '品格高尚 · 志节纯洁',
  description: '高义白洁，形容人品德高尚、志节纯洁，是中华传统文化中对君子人格的最高赞誉。本网站深度解析高义白洁的文化内涵、历史渊源与现代价值，帮助读者理解并践行这一崇高品格。',
  url: 'https://www.gaoyibaijie.com',
  locale: 'zh-CN',
  foundingDate: '2020-01-01',
  email: 'contact@gaoyibaijie.com',
  address: {
    street: '文化路88号国学大厦',
    city: '北京',
    region: '北京市',
    postalCode: '100000',
    country: 'CN',
  },
  geo: {
    latitude: '39.9042',
    longitude: '116.4074',
  },
};

export const navigationLinks = [
  { label: '首页', href: '/', icon: 'ri-home-line' },
  { label: '文化内涵', href: '/category/wenhua-neihan' },
  { label: '历史典故', href: '/category/lishi-diangu' },
  { label: '现代价值', href: '/category/xiandai-jiazhi' },
  { label: '修养方法', href: '/category/xiuyang-fangfa' },
  { label: '关于我们', href: '/about' },
];